import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=218750f0&scoped=true"
import script from "./DocumentEditor.vue?vue&type=script&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=218750f0&prod&lang=scss&scoped=true"
import style1 from "./DocumentEditor.vue?vue&type=style&index=1&id=218750f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218750f0",
  null
  
)

export default component.exports